module.exports = __webpack_public_path__ + "static/media/google-meet.44c24d17.svg";